<template>
  <div ref="rightPanel" :class="show ? 'show' : ''" class="rightPanel-container">
    <div class="rightPanel-background" />
    <div class="rightPanel">
      <div class="handle-button" v-tooltip="tooltip" :style="{'top':buttonTop+'px','background-color':theme}" @click="show=!show">
        <i :class="show?'el-icon-close':'fas fa-cogs'" />
      </div>
      <div class="rightPanel-items">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { addClass, removeClass } from './utils'

export default {
  name: 'RightPanel',
  props: {
    clickNotClose: {
      default: false,
      type: Boolean
    },
    tooltip: {
      default: '',
      type: String
      },
    buttonTop: {
      default: 110,
      type: Number
    },
    open: {
    default: false,
    type: Boolean
    }
  },
  data() {
    return {
      show: this.open ? true : false
    }
  },
  computed: {
    theme() {
      return null
    },
		 color() {
			return 'transparent'
			}
  },
  watch: {
    show(value) {
            if (window.PlotlyInstance && document.getElementById('pcaDiv')) {
            PlotlyInstance.Fx.unhover('pcaDiv')
            }
      if (value && !this.clickNotClose) {
        this.addEventClick()
      }
      if (value) {
        addClass(document.body, 'showRightPanel')
      } else {
        window.removeEventListener('click', this.closeSidebar)
        removeClass(document.body, 'showRightPanel')
      }
    }
  },
  mounted() {
    this.insertToBody()
        let w = this;
        this.$root.$on('rightpanel', (action) => {
	      if (action === 'close') {
        w.show = false;
	      } else if (action === 'open') {
                w.show = true;          
                }
        })
  },
  beforeDestroy() {
    const elx = this.$refs.rightPanel
    elx.remove()
  },
  methods: {
    addEventClick() {
      window.addEventListener('click', this.closeSidebar)
    },
    closeSidebar(evt) {
      const parent = evt.target.closest('.rightPanel')
      const multiselect = evt.target.className.indexOf('multiselect')
      const reset = evt.target.className.indexOf('reset')
      if (!parent && multiselect < 0 && reset < 0) {
        this.show = false
        window.removeEventListener('click', this.closeSidebar)
      }
    },
    insertToBody() {
      const elx = this.$refs.rightPanel
      const body = document.querySelector('body')
      body.insertBefore(elx, body.firstChild)
    }
  }
}
</script>

<style>
.showRightPanel {
  overflow: hidden;
  position: relative;
  /*width: calc(100% - 15px);*/
}

</style>

<style lang="scss" scoped>
.rightPanel-background {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity .3s cubic-bezier(.7, .3, .1, 1);
  background: rgba(0, 0, 0, .2);
  z-index: -1;
}

.rightPanel {
  width: 100%;
  max-width: 260px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, .05);
  transition: all .25s cubic-bezier(.7, .3, .1, 1);
  transform: translate(100%);
  background: #fff;
  z-index: 40000;
}

.show {
  transition: all .3s cubic-bezier(.7, .3, .1, 1);

  .rightPanel-background {
    z-index: 20000;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  background: white;
  width: 45px;
  height: 48px;
  border-left: 1px solid #aaaaaab3;
  position: absolute;
  left: -45px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  color: #337088;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}
body.dark .handle-button {
    background: #121212;
    color: white;
 transition: color 0.3s, background 0.3s, background-color 0.3s;}
</style>
